// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"909":"ce2821bddb7990d2","927":"13349c4680330f9c"}[chunkId] + ".js";
};